import React,{useState} from 'react';
import {connect} from 'react-redux';

import useAuthStatus from '../../hooks/authHook';

import './header.css';

const Header = ({auth})=>{
  const [search,setSearch]=useState('');
  const isLogged=useAuthStatus(auth.token);


  if(!isLogged) {
    return false;
  }

  const onChange = (handler)=>{
    return ({target})=>{
      return handler(target.value);
    }
  }


  return (
    <div id="header">
      <div className="input-icon">
        <input type="text" value={search} onChange={onChange(setSearch)} />
        <button type="button"><i className="icon-search"></i></button>
      </div>
    </div>
  )
}

const mapState2Props=(state)=>({
  auth:state.auth
})

export default connect(mapState2Props)(Header);